import { render, staticRenderFns } from "./TributacaoSelector.vue?vue&type=template&id=6af2377c&scoped=true"
import script from "./TributacaoSelector.vue?vue&type=script&lang=js"
export * from "./TributacaoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af2377c",
  null
  
)

export default component.exports